// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file entitlements/v3/entitlements.proto (package entitlements.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Feature } from "./features_pb";
import { file_entitlements_v3_features } from "./features_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entitlements/v3/entitlements.proto.
 */
export const file_entitlements_v3_entitlements: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_duration, file_common_v3_common, file_entitlements_v3_features]);

/**
 * Entitlement defines a feature with its associated limits and controls.
 * It combines a feature definition with various categorized constraints.
 *
 * Example use case:
 * - Defining a "Premium Chat" feature with context window of 100k tokens,
 *   5 RPM rate limit, 365-day retention period, and 1000 requests monthly quota
 * - Setting up a "Document Analysis" feature with 50MB file size limit,
 *   batch processing of 10 files, and enterprise compliance controls
 *
 * Common feature type to limit type mappings:
 * - Upload Features: ingest_limits, rate_limits, quota_limits
 * - Storage Features: resource_limits, time_limits (retention)
 * - API Features: rate_limits, quota_limits, time_limits (timeouts)
 * - Content Features: content_limits, quota_limits, compliance_controls
 *
 * Most features will utilize feature_flags.
 *
 * Most features will also use availability_controls to encourage people
 * to take an action such as registering or changing their plan. We can do this
 * by communicating to users when a feature becomes available to them again
 * (e.g., "this feature is unavailable until tomorrow at 10:00 AM"
 * or "this feature has a 5-minute cool down period").
 *
 * Simply omitting a feature from the entitlement list is equivalent to
 * disabling it (e.g., a feature flag).
 *
 * @generated from message entitlements.v3.Entitlement
 */
export type Entitlement = Message<"entitlements.v3.Entitlement"> & {
  /**
   * The feature this entitlement applies to
   * Example: Feature with ID "premium_chat" and name "Premium Chat"
   *
   * @generated from field: entitlements.v3.Feature feature = 1;
   */
  feature: Feature;

  /**
   * Physical resource constraints such as storage space
   * Example: 1GB storage limit for chat history and attachments
   *
   * @generated from field: optional entitlements.v3.ResourceConstraints resource_limits = 2;
   */
  resourceLimits: ResourceConstraints;

  /**
   * Operation frequency constraints (RPS, RPM, etc.)
   * Example: 60 requests per minute limit to prevent abuse
   *
   * @generated from field: optional entitlements.v3.RateConstraints rate_limits = 3;
   */
  rateLimits: RateConstraints;

  /**
   * Duration or retention constraints
   * Example: 30-day retention period for conversation history
   *
   * @generated from field: optional entitlements.v3.TimeConstraints time_limits = 4;
   */
  timeLimits: TimeConstraints;

  /**
   * Content dimension constraints such as context window size
   * Example: 16K token context window size limit
   *
   * @generated from field: optional entitlements.v3.ContentConstraints content_limits = 5;
   */
  contentLimits: ContentConstraints;

  /**
   * Usage quota constraints for hourly, daily or monthly periods
   * Example: 1000 chat messages per month quota
   *
   * @generated from field: optional entitlements.v3.QuotaConstraints quota_limits = 6;
   */
  quotaLimits: QuotaConstraints;

  /**
   * Batch processing constraints on size and frequency
   * Example: Allowing processing of up to 50 images in a batch
   *
   * @generated from field: optional entitlements.v3.BatchConstraints batch_limits = 7;
   */
  batchLimits: BatchConstraints;

  /**
   * Time-based controls that determine when features become available
   * Example: Feature will be available after 2025-05-01
   *
   * @generated from field: optional entitlements.v3.AvailabilityConstraints availability_controls = 8;
   */
  availabilityControls: AvailabilityConstraints;

  /**
   * Data ingestion constraints for uploads and processing
   * Example: Limiting uploads to 10 files per session
   *
   * @generated from field: optional entitlements.v3.IngestConstraints ingest_limits = 9;
   */
  ingestLimits: IngestConstraints;

  /**
   * API-specific constraints
   * Example: Allowing up to 5 custom API keys per account
   *
   * @generated from field: optional entitlements.v3.APIConstraints api_limits = 10;
   */
  apiLimits: APIConstraints;

  /**
   * Audit and compliance controls
   * Example: Enabling PII filtering for enterprise customers
   *
   * @generated from field: optional entitlements.v3.ComplianceConstraints compliance_controls = 11;
   */
  complianceControls: ComplianceConstraints;

  /**
   * Workflow execution constraints
   *
   * @generated from field: optional entitlements.v3.WorkflowConstraints workflow_limits = 12;
   */
  workflowLimits: WorkflowConstraints;

  /**
   * Full audit metadata for this entitlement.
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 13;
   */
  auditMetadata: AuditMetadata;
};

/**
 * Describes the message entitlements.v3.Entitlement.
 * Use `create(EntitlementSchema)` to create a new message.
 */
export const EntitlementSchema: GenMessage<Entitlement> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 0);

/**
 * ResourceConstraints groups all resource limit types
 *
 * @generated from message entitlements.v3.ResourceConstraints
 */
export type ResourceConstraints = Message<"entitlements.v3.ResourceConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.ResourceLimit limits = 1;
   */
  limits: ResourceLimit[];
};

/**
 * Describes the message entitlements.v3.ResourceConstraints.
 * Use `create(ResourceConstraintsSchema)` to create a new message.
 */
export const ResourceConstraintsSchema: GenMessage<ResourceConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 1);

/**
 * RateConstraints groups all rate limit types
 *
 * @generated from message entitlements.v3.RateConstraints
 */
export type RateConstraints = Message<"entitlements.v3.RateConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.RateLimit limits = 1;
   */
  limits: RateLimit[];
};

/**
 * Describes the message entitlements.v3.RateConstraints.
 * Use `create(RateConstraintsSchema)` to create a new message.
 */
export const RateConstraintsSchema: GenMessage<RateConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 2);

/**
 * TimeConstraints groups all time limit types
 *
 * @generated from message entitlements.v3.TimeConstraints
 */
export type TimeConstraints = Message<"entitlements.v3.TimeConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.TimeLimit limits = 1;
   */
  limits: TimeLimit[];
};

/**
 * Describes the message entitlements.v3.TimeConstraints.
 * Use `create(TimeConstraintsSchema)` to create a new message.
 */
export const TimeConstraintsSchema: GenMessage<TimeConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 3);

/**
 * ContentConstraints groups all content limit types
 *
 * @generated from message entitlements.v3.ContentConstraints
 */
export type ContentConstraints = Message<"entitlements.v3.ContentConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.ContentLimit limits = 1;
   */
  limits: ContentLimit[];
};

/**
 * Describes the message entitlements.v3.ContentConstraints.
 * Use `create(ContentConstraintsSchema)` to create a new message.
 */
export const ContentConstraintsSchema: GenMessage<ContentConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 4);

/**
 * QuotaConstraints groups all quota limit types
 *
 * @generated from message entitlements.v3.QuotaConstraints
 */
export type QuotaConstraints = Message<"entitlements.v3.QuotaConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.QuotaLimit limits = 1;
   */
  limits: QuotaLimit[];
};

/**
 * Describes the message entitlements.v3.QuotaConstraints.
 * Use `create(QuotaConstraintsSchema)` to create a new message.
 */
export const QuotaConstraintsSchema: GenMessage<QuotaConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 5);

/**
 * BatchConstraints groups all batch limit types
 *
 * @generated from message entitlements.v3.BatchConstraints
 */
export type BatchConstraints = Message<"entitlements.v3.BatchConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.BatchLimit limits = 1;
   */
  limits: BatchLimit[];
};

/**
 * Describes the message entitlements.v3.BatchConstraints.
 * Use `create(BatchConstraintsSchema)` to create a new message.
 */
export const BatchConstraintsSchema: GenMessage<BatchConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 6);

/**
 * AvailabilityConstraints groups all availability control types
 *
 * @generated from message entitlements.v3.AvailabilityConstraints
 */
export type AvailabilityConstraints = Message<"entitlements.v3.AvailabilityConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.AvailabilityControl controls = 1;
   */
  controls: AvailabilityControl[];
};

/**
 * Describes the message entitlements.v3.AvailabilityConstraints.
 * Use `create(AvailabilityConstraintsSchema)` to create a new message.
 */
export const AvailabilityConstraintsSchema: GenMessage<AvailabilityConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 7);

/**
 * IngestConstraints groups all ingest limit types
 *
 * @generated from message entitlements.v3.IngestConstraints
 */
export type IngestConstraints = Message<"entitlements.v3.IngestConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.IngestLimit limits = 1;
   */
  limits: IngestLimit[];
};

/**
 * Describes the message entitlements.v3.IngestConstraints.
 * Use `create(IngestConstraintsSchema)` to create a new message.
 */
export const IngestConstraintsSchema: GenMessage<IngestConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 8);

/**
 * APIConstraints groups all API limit types
 *
 * @generated from message entitlements.v3.APIConstraints
 */
export type APIConstraints = Message<"entitlements.v3.APIConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.APILimit limits = 1;
   */
  limits: APILimit[];
};

/**
 * Describes the message entitlements.v3.APIConstraints.
 * Use `create(APIConstraintsSchema)` to create a new message.
 */
export const APIConstraintsSchema: GenMessage<APIConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 9);

/**
 * ComplianceConstraints groups all compliance control types
 *
 * @generated from message entitlements.v3.ComplianceConstraints
 */
export type ComplianceConstraints = Message<"entitlements.v3.ComplianceConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.ComplianceControl controls = 1;
   */
  controls: ComplianceControl[];
};

/**
 * Describes the message entitlements.v3.ComplianceConstraints.
 * Use `create(ComplianceConstraintsSchema)` to create a new message.
 */
export const ComplianceConstraintsSchema: GenMessage<ComplianceConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 10);

/**
 * WorkflowConstraints groups all workflow limit types
 *
 * @generated from message entitlements.v3.WorkflowConstraints
 */
export type WorkflowConstraints = Message<"entitlements.v3.WorkflowConstraints"> & {
  /**
   * @generated from field: repeated entitlements.v3.WorkflowLimit limits = 1;
   */
  limits: WorkflowLimit[];
};

/**
 * Describes the message entitlements.v3.WorkflowConstraints.
 * Use `create(WorkflowConstraintsSchema)` to create a new message.
 */
export const WorkflowConstraintsSchema: GenMessage<WorkflowConstraints> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 11);

/**
 * Base message for common limit period properties
 *
 * Example use case:
 * - Tracking a user's monthly quota for API calls, showing they've used 75% of
 *   their allowance with 8 days left
 * - Measuring the current billing cycle for a professional account with
 *   daily limits
 * - Implementing a cool-down period for high-frequency operations
 *
 * @generated from message entitlements.v3.LimitPeriod
 */
export type LimitPeriod = Message<"entitlements.v3.LimitPeriod"> & {
  /**
   * When the current limit period started
   * Example: 2025-04-01T00:00:00Z for a monthly billing cycle starting on April 1st
   *
   * @generated from field: google.protobuf.Timestamp period_start = 1;
   */
  periodStart: Timestamp;

  /**
   * When the current limit period ends/resets
   * Example: 2025-04-30T23:59:59Z for a monthly period ending on April 30th
   *
   * @generated from field: google.protobuf.Timestamp period_end = 2;
   */
  periodEnd: Timestamp;

  /**
   * Percentage of limit currently used (0.0-1.0)
   * Example: 0.75 indicates the user has consumed 75% of their limit for
   * this period
   *
   * @generated from field: float usage_percentage = 3;
   */
  usagePercentage: number;
};

/**
 * Describes the message entitlements.v3.LimitPeriod.
 * Use `create(LimitPeriodSchema)` to create a new message.
 */
export const LimitPeriodSchema: GenMessage<LimitPeriod> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 12);

/**
 * For integer-based limits (storage, counts, etc.)
 *
 * Example use case:
 * - Limiting total number of conversations to 100 for free users
 * - Tracking storage usage at 512MB out of a 1GB limit
 *
 * @generated from message entitlements.v3.IntegerLimit
 */
export type IntegerLimit = Message<"entitlements.v3.IntegerLimit"> & {
  /**
   * Maximum allowed value
   * Example: 100 as maximum number of saved conversations
   *
   * @generated from field: int64 limit = 1;
   */
  limit: bigint;

  /**
   * Current usage amount
   * Example: 42 conversations currently stored
   *
   * @generated from field: int64 usage = 2;
   */
  usage: bigint;

  /**
   * Period information
   * Example: Period showing this limit resets monthly on the 1st
   *
   * @generated from field: entitlements.v3.LimitPeriod period = 3;
   */
  period: LimitPeriod;
};

/**
 * Describes the message entitlements.v3.IntegerLimit.
 * Use `create(IntegerLimitSchema)` to create a new message.
 */
export const IntegerLimitSchema: GenMessage<IntegerLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 13);

/**
 * For floating point limits (percentages, costs, etc.)
 *
 * Example use case:
 * - Tracking cost-based usage at $12.75 of a $20 monthly allowance
 * - Setting temperature limit of 0.8 for a model parameter
 * - Implementing a 15.5% discount on token usage for enterprise accounts
 *
 * @generated from message entitlements.v3.FloatLimit
 */
export type FloatLimit = Message<"entitlements.v3.FloatLimit"> & {
  /**
   * Maximum allowed value
   * Example: 20.0 maximum monthly cost allowed in dollars
   *
   * @generated from field: float limit = 1;
   */
  limit: number;

  /**
   * Current usage amount
   * Example: 12.75 dollars used so far this month
   *
   * @generated from field: float usage = 2;
   */
  usage: number;

  /**
   * Period information
   * Example: Period indicating the billing cycle with 9 days remaining
   *
   * @generated from field: entitlements.v3.LimitPeriod period = 3;
   */
  period: LimitPeriod;
};

/**
 * Describes the message entitlements.v3.FloatLimit.
 * Use `create(FloatLimitSchema)` to create a new message.
 */
export const FloatLimitSchema: GenMessage<FloatLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 14);

/**
 * TimeLimit defines constraints on durations or retention periods
 *
 * Example use case:
 * - Setting a 30-minute maximum for conversation session timeouts
 * - Defining a 7-day data retention policy for free tier conversations
 * - Implementing a 120-second context deadline for enterprise users and a
 *   60 second deadline for free users
 *
 * @generated from message entitlements.v3.TimeLimit
 */
export type TimeLimit = Message<"entitlements.v3.TimeLimit"> & {
  /**
   * Type of time constraint
   * Example: TIME_INACTIVITY_TIMEOUT for session expiration
   *
   * @generated from field: entitlements.v3.TimeLimitType type = 1;
   */
  type: TimeLimitType;

  /**
   * Time limit as a standard duration
   * Example: 30 minutes as maximum session duration
   *
   * @generated from field: google.protobuf.Duration limit = 2;
   */
  limit: Duration;

  /**
   * Current usage
   * Example: 18 minutes elapsed in current session
   *
   * @generated from field: google.protobuf.Duration usage = 3;
   */
  usage: Duration;

  /**
   * Period information
   * Example: Period tracking when the session started and when it will expire
   *
   * @generated from field: entitlements.v3.LimitPeriod period = 4;
   */
  period: LimitPeriod;
};

/**
 * Describes the message entitlements.v3.TimeLimit.
 * Use `create(TimeLimitSchema)` to create a new message.
 */
export const TimeLimitSchema: GenMessage<TimeLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 15);

/**
 * IngestLimit defines constraints on data ingestion operations
 *
 * Example use case:
 * - Limiting file uploads to 10 files per batch for standard users
 * - Restricting CSV imports to 1,000 records for the basic plan
 * - Setting maximum field count to 100 for imported data or tabular data
 *
 * @generated from message entitlements.v3.IngestLimit
 */
export type IngestLimit = Message<"entitlements.v3.IngestLimit"> & {
  /**
   * Type of ingest constraint being applied
   * Example: INGEST_MAX_FILES_PER_UPLOAD for file count restriction
   *
   * @generated from field: entitlements.v3.IngestLimitType type = 1;
   */
  type: IngestLimitType;

  /**
   * Integer-based ingest limit with usage tracking
   * Example: Limit of 10 files with current usage of 3 files
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;
};

/**
 * Describes the message entitlements.v3.IngestLimit.
 * Use `create(IngestLimitSchema)` to create a new message.
 */
export const IngestLimitSchema: GenMessage<IngestLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 16);

/**
 * ResourceLimit defines constraints on physical resources like storage
 *
 * Example use case:
 * - Setting a 2GB storage limit for chat history
 * - Limiting a prompt library to 10 for guest accounts
 *
 * @generated from message entitlements.v3.ResourceLimit
 */
export type ResourceLimit = Message<"entitlements.v3.ResourceLimit"> & {
  /**
   * Type of resource being limited
   * Example: RESOURCE_STORAGE_BYTES for storage allocation
   *
   * @generated from field: entitlements.v3.ResourceLimitType type = 1;
   */
  type: ResourceLimitType;

  /**
   * Integer-based resource limit with usage tracking
   * Example: 2GB (2,147,483,648 bytes) limit with 500MB current usage
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;
};

/**
 * Describes the message entitlements.v3.ResourceLimit.
 * Use `create(ResourceLimitSchema)` to create a new message.
 */
export const ResourceLimitSchema: GenMessage<ResourceLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 17);

/**
 * RateLimit defines constraints on operation frequency. Primary target
 * for third-party integrations on our APIs.
 *
 * Example use case:
 * - Limiting API usage to 60 requests per minute
 * - Setting a 5 requests per second limit for specific endpoints
 * - Implementing a 1000 requests per day limit for free tier accounts
 *
 * @generated from message entitlements.v3.RateLimit
 */
export type RateLimit = Message<"entitlements.v3.RateLimit"> & {
  /**
   * Type of rate being limited
   * Example: RATE_RPM for requests-per-minute limits
   *
   * @generated from field: entitlements.v3.RateLimitType type = 1;
   */
  type: RateLimitType;

  /**
   * Rate limit value with usage tracking
   * Example: 60.0 RPM limit with current usage at 45.5 RPM
   *
   * @generated from field: entitlements.v3.FloatLimit value = 2;
   */
  value: FloatLimit;
};

/**
 * Describes the message entitlements.v3.RateLimit.
 * Use `create(RateLimitSchema)` to create a new message.
 */
export const RateLimitSchema: GenMessage<RateLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 18);

/**
 * ContentLimit defines constraints on content dimensions or quantities
 *
 * Example use case:
 * - Setting a 16K token context window for premium users
 * - Limiting input length to 4,000 characters for free tier
 * - Restricting output length to 1,000 tokens per response
 *
 * @generated from message entitlements.v3.ContentLimit
 */
export type ContentLimit = Message<"entitlements.v3.ContentLimit"> & {
  /**
   * Type of content being limited
   * Example: CONTENT_CONTEXT_WINDOW for token context limits
   *
   * @generated from field: entitlements.v3.ContentLimitType type = 1;
   */
  type: ContentLimitType;

  /**
   * Content limit value with usage tracking
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;

  /**
   * Whether this quota allows short bursts over the limit
   * Example: true to allow temporary exceeding of RPM limits
   *
   * @generated from field: bool allows_bursting = 3;
   */
  allowsBursting: boolean;
};

/**
 * Describes the message entitlements.v3.ContentLimit.
 * Use `create(ContentLimitSchema)` to create a new message.
 */
export const ContentLimitSchema: GenMessage<ContentLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 19);

/**
 * AvailabilityControl may be used to communicate to users when a feature
 * becomes available to them again.
 *
 * For example, "this feature is unavailable until tomorrow at 10:00 AM"
 * or "this feature has a 5-minute cool down period". These controls are
 * are typically to encourage humans to take action such as registering an
 * account or updating their plan.
 *
 * Example use case:
 * - Making a feature available after a specific release date
 * - Implementing a cool-down period after intensive resource usage
 * - Communicating to users when a rate-limited feature will be available again
 * - Encouraging users to take an action such as upgrading their plan
 *
 * @generated from message entitlements.v3.AvailabilityControl
 */
export type AvailabilityControl = Message<"entitlements.v3.AvailabilityControl"> & {
  /**
   * Type of availability control
   * Example: AVAILABILITY_FUTURE_TIMESTAMP for beta features
   *
   * @generated from field: entitlements.v3.AvailabilityControlType type = 1;
   */
  type: AvailabilityControlType;

  /**
   * Specific timestamp when feature becomes available. May be used for
   * cool-down periods or future availability.
   * Example: 2025-05-15T14:00:00Z for a feature launching next month
   *
   * @generated from field: google.protobuf.Timestamp available_at = 2;
   */
  availableAt: Timestamp;
};

/**
 * Describes the message entitlements.v3.AvailabilityControl.
 * Use `create(AvailabilityControlSchema)` to create a new message.
 */
export const AvailabilityControlSchema: GenMessage<AvailabilityControl> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 20);

/**
 * QuotaLimit defines constraints on usage quotas and budgets
 *
 * Example use case:
 * - Setting a $10 monthly spending limit for API usage
 * - Implementing a 1,000 requests daily quota for free tier
 * - Creating a credits-based system with 500 monthly credits
 *
 * @generated from message entitlements.v3.QuotaLimit
 */
export type QuotaLimit = Message<"entitlements.v3.QuotaLimit"> & {
  /**
   * Type of quota being limited
   * Example: QUOTA_DAILY for daily usage tracking
   *
   * @generated from field: entitlements.v3.QuotaLimitType type = 1;
   */
  type: QuotaLimitType;

  /**
   * Quota limit value with usage tracking
   * Example: 1,000 request daily limit with 750 used
   *
   * @generated from field: entitlements.v3.FloatLimit float_value = 2;
   */
  floatValue: FloatLimit;

  /**
   * Whether this is a hard limit (exceeding causes rejections)
   * Example: true to reject requests when quota is exceeded
   *
   * @generated from field: bool hard_limit = 3;
   */
  hardLimit: boolean;

  /**
   * Whether this quota allows short bursts over the limit
   * Example: true to allow temporary exceeding of RPM limits
   *
   * @generated from field: bool allows_bursting = 4;
   */
  allowsBursting: boolean;
};

/**
 * Describes the message entitlements.v3.QuotaLimit.
 * Use `create(QuotaLimitSchema)` to create a new message.
 */
export const QuotaLimitSchema: GenMessage<QuotaLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 21);

/**
 * BatchLimit defines constraints on batch processing
 *
 * Example use case:
 * - Limiting batch API calls to 50 items per request
 * - Restricting batch processing to 5 operations per hour
 * - Setting maximum concurrent running actions to 3
 *
 * @generated from message entitlements.v3.BatchLimit
 */
export type BatchLimit = Message<"entitlements.v3.BatchLimit"> & {
  /**
   * Type of batch constraint
   * Example: BATCH_SIZE for maximum items per batch
   *
   * @generated from field: entitlements.v3.BatchLimitType type = 1;
   */
  type: BatchLimitType;

  /**
   * Integer-based batch limit with usage tracking
   * Example: 50 item batch size limit with 30 items in current batch
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;
};

/**
 * Describes the message entitlements.v3.BatchLimit.
 * Use `create(BatchLimitSchema)` to create a new message.
 */
export const BatchLimitSchema: GenMessage<BatchLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 22);

/**
 * APILimit defines constraints on API usage
 *
 * Example use case:
 * - Limiting accounts to 5 API keys maximum
 * - Restricting integrations to 3 per account for standard tier
 * - Allowing up to 3 integrations for basic plan users
 *
 * @generated from message entitlements.v3.APILimit
 */
export type APILimit = Message<"entitlements.v3.APILimit"> & {
  /**
   * Type of API limit
   * Example: API_MAX_KEYS for API key restrictions
   *
   * @generated from field: entitlements.v3.APILimitType type = 1;
   */
  type: APILimitType;

  /**
   * Integer-based API limit with usage tracking
   * Example: 5 API key limit with 2 keys currently used
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;
};

/**
 * Describes the message entitlements.v3.APILimit.
 * Use `create(APILimitSchema)` to create a new message.
 */
export const APILimitSchema: GenMessage<APILimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 23);

/**
 * WorkflowLimit defines constraints on workflow execution
 *
 * Example use case:
 * - Limiting workflow to maximum 5 steps for basic tier
 * - Restricting recursive workflow depth to 3 levels for standard plan
 * - Setting total action limit to 20 per workflow for premium tier
 *
 * @generated from message entitlements.v3.WorkflowLimit
 */
export type WorkflowLimit = Message<"entitlements.v3.WorkflowLimit"> & {
  /**
   * Type of workflow constraint being applied
   * Example: WORKFLOW_MAX_STEPS for step count restriction
   *
   * @generated from field: entitlements.v3.WorkflowLimitType type = 1;
   */
  type: WorkflowLimitType;

  /**
   * Integer-based workflow limit with usage tracking
   * Example: Limit of 10 steps with current usage of 4 steps
   *
   * @generated from field: entitlements.v3.IntegerLimit value = 2;
   */
  value: IntegerLimit;
};

/**
 * Describes the message entitlements.v3.WorkflowLimit.
 * Use `create(WorkflowLimitSchema)` to create a new message.
 */
export const WorkflowLimitSchema: GenMessage<WorkflowLimit> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 24);

/**
 * ComplianceControl defines audit and compliance controls
 *
 * Example use case:
 * - Enabling audit logging for enterprise customers
 * - Setting 90-day retention policy for compliance logs
 * - Implementing EU-only data residency requirements
 * - Configuring PII handling policies for medical data
 *
 * @generated from message entitlements.v3.ComplianceControl
 */
export type ComplianceControl = Message<"entitlements.v3.ComplianceControl"> & {
  /**
   * Type of compliance control
   * Example: COMPLIANCE_AUDIT_LOGGING for audit trail
   *
   * @generated from field: entitlements.v3.ComplianceControlType type = 1;
   */
  type: ComplianceControlType;

  /**
   * Value of the compliance control, depends on the control type
   *
   * @generated from oneof entitlements.v3.ComplianceControl.value
   */
  value: {
    /**
     * Boolean indicating if feature is enabled
     * Example: true to enable detailed audit logging
     *
     * @generated from field: bool is_enabled = 2;
     */
    value: boolean;
    case: "isEnabled";
  } | {
    /**
     * Retention period in days
     * Example: 90 days retention for compliance with financial regulations
     *
     * @generated from field: int64 retention_days = 3;
     */
    value: bigint;
    case: "retentionDays";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message entitlements.v3.ComplianceControl.
 * Use `create(ComplianceControlSchema)` to create a new message.
 */
export const ComplianceControlSchema: GenMessage<ComplianceControl> = /*@__PURE__*/
  messageDesc(file_entitlements_v3_entitlements, 25);

/**
 * TimeLimitType enumerates the different types of time limits
 *
 * @generated from enum entitlements.v3.TimeLimitType
 */
export enum TimeLimitType {
  /**
   * @generated from enum value: TIME_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum operation runtime, including processing time (deadline).
   * Example: Setting a 20-second maximum for completing a complex query
   *
   * @generated from enum value: TIME_LIMIT_TYPE_OPERATION_RUNTIME = 1;
   */
  OPERATION_RUNTIME = 1,

  /**
   * Inactivity timeout threshold
   * Example: Failing a job if no updates are observed within 5 minutes.
   *
   * @generated from enum value: TIME_LIMIT_TYPE_INACTIVITY_TIMEOUT = 2;
   */
  INACTIVITY_TIMEOUT = 2,

  /**
   * Time-to-live before expiration
   * Example: Setting image uploads to expire after 24 hours
   *
   * @generated from enum value: TIME_LIMIT_TYPE_TTL = 3;
   */
  TTL = 3,

  /**
   * Data retention period
   * Example: Retaining chat histories for 30 days before automatic deletion
   *
   * @generated from enum value: TIME_LIMIT_TYPE_RETENTION = 4;
   */
  RETENTION = 4,
}

/**
 * Describes the enum entitlements.v3.TimeLimitType.
 */
export const TimeLimitTypeSchema: GenEnum<TimeLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 0);

/**
 * IngestLimitType enumerates the different types of ingest limits
 *
 * @generated from enum entitlements.v3.IngestLimitType
 */
export enum IngestLimitType {
  /**
   * @generated from enum value: INGEST_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum number of files allowed in a single upload
   * Example: Allowing up to 5 PDFs to be uploaded at once
   *
   * @generated from enum value: INGEST_LIMIT_TYPE_MAX_FILES_PER_UPLOAD = 1;
   */
  MAX_FILES_PER_UPLOAD = 1,

  /**
   * Maximum number of records that can be ingested from API or tabular data
   * Example: Restricting CSV imports to 1,000 rows for guest accounts
   *
   * @generated from enum value: INGEST_LIMIT_TYPE_MAX_RECORDS = 2;
   */
  MAX_RECORDS = 2,

  /**
   * Maximum number of fields per record allowed (columns, API fields, etc.)
   * Example: Limiting imported data to 50 columns for efficient processing
   *
   * @generated from enum value: INGEST_LIMIT_TYPE_MAX_FIELDS = 3;
   */
  MAX_FIELDS = 3,

  /**
   * Maximum number of pages or sheets to process
   * Example: Processing only the first 100 pages of a PDF or 3 Excel sheets
   *
   * @generated from enum value: INGEST_LIMIT_TYPE_MAX_PAGES = 4;
   */
  MAX_PAGES = 4,

  /**
   * Maximum depth for labels, relationships, or hierarchical structures
   * Example: Limiting knowledge graph relationships to 3 levels deep
   *
   * @generated from enum value: INGEST_LIMIT_TYPE_MAX_DEPTH = 5;
   */
  MAX_DEPTH = 5,
}

/**
 * Describes the enum entitlements.v3.IngestLimitType.
 */
export const IngestLimitTypeSchema: GenEnum<IngestLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 1);

/**
 * ResourceLimitType enumerates the different types of resource limits
 *
 * @generated from enum entitlements.v3.ResourceLimitType
 */
export enum ResourceLimitType {
  /**
   * @generated from enum value: RESOURCE_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum storage size in bytes
   * Example: 1GB (1,073,741,824 bytes) storage limit for free accounts
   *
   * @generated from enum value: RESOURCE_LIMIT_TYPE_STORAGE_BYTES = 1;
   */
  STORAGE_BYTES = 1,

  /**
   * Maximum total number of resources
   * Example: 10 assets in a knowledge base for guests
   *
   * @generated from enum value: RESOURCE_LIMIT_TYPE_MAX_COUNT = 2;
   */
  MAX_COUNT = 2,

  /**
   * Maximum number of active resources
   * Example: 10 non-deleted assets in a knowledge base
   *
   * @generated from enum value: RESOURCE_LIMIT_TYPE_MAX_ACTIVE = 3;
   */
  MAX_ACTIVE = 3,
}

/**
 * Describes the enum entitlements.v3.ResourceLimitType.
 */
export const ResourceLimitTypeSchema: GenEnum<ResourceLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 2);

/**
 * RateLimitType enumerates the different types of rate limits
 *
 * @generated from enum entitlements.v3.RateLimitType
 */
export enum RateLimitType {
  /**
   * @generated from enum value: RATE_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum Requests Per Second allowed
   * Example: 5 requests per second for high-traffic endpoints
   *
   * @generated from enum value: RATE_LIMIT_TYPE_RPS = 1;
   */
  RPS = 1,

  /**
   * Maximum Requests Per Minute allowed
   * Example: 60 requests per minute for standard API usage
   *
   * @generated from enum value: RATE_LIMIT_TYPE_RPM = 2;
   */
  RPM = 2,

  /**
   * Maximum Requests Per Hour allowed
   * Example: 500 requests per hour for batch processing
   *
   * @generated from enum value: RATE_LIMIT_TYPE_RPH = 3;
   */
  RPH = 3,

  /**
   * Maximum Requests Per Day allowed
   * Example: 1000 requests per day for free tier accounts
   *
   * @generated from enum value: RATE_LIMIT_TYPE_RPD = 4;
   */
  RPD = 4,
}

/**
 * Describes the enum entitlements.v3.RateLimitType.
 */
export const RateLimitTypeSchema: GenEnum<RateLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 3);

/**
 * ContentLimitType enumerates the different types of content limits
 *
 * @generated from enum entitlements.v3.ContentLimitType
 */
export enum ContentLimitType {
  /**
   * @generated from enum value: CONTENT_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum size of context window per request
   * Example: 100K token context window for enterprise tier
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_CONTEXT_WINDOW = 1;
   */
  CONTEXT_WINDOW = 1,

  /**
   * Maximum length allowed for a single input
   * Example: 4,000 character limit for user prompts
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_INPUT_LENGTH = 2;
   */
  INPUT_LENGTH = 2,

  /**
   * Maximum length allowed for a single output
   * Example: 2,000 token limit for AI responses
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_OUTPUT_LENGTH = 3;
   */
  OUTPUT_LENGTH = 3,

  /**
   * Maximum size of request payload in bytes
   * Example: 1MB (1,048,576 bytes) request size limit
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_REQUEST_PAYLOAD_SIZE = 4;
   */
  REQUEST_PAYLOAD_SIZE = 4,

  /**
   * Maximum size of response payload in bytes
   * Example: 5MB (5,242,880 bytes) response size limit
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_RESPONSE_PAYLOAD_SIZE = 5;
   */
  RESPONSE_PAYLOAD_SIZE = 5,

  /**
   * Maximum number of tokens per request
   * Example: 4,096 token limit per API call
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_MAX_TOKENS_PER_REQUEST = 6;
   */
  MAX_TOKENS_PER_REQUEST = 6,

  /**
   * Maximum message history length
   * Example: 100 message history limit for a conversation
   *
   * @generated from enum value: CONTENT_LIMIT_TYPE_MAX_HISTORY_LENGTH = 7;
   */
  MAX_HISTORY_LENGTH = 7,
}

/**
 * Describes the enum entitlements.v3.ContentLimitType.
 */
export const ContentLimitTypeSchema: GenEnum<ContentLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 4);

/**
 * AvailabilityControlType enumerates the different types of availability controls
 *
 * @generated from enum entitlements.v3.AvailabilityControlType
 */
export enum AvailabilityControlType {
  /**
   * @generated from enum value: AVAILABILITY_CONTROL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Feature becomes available after a specific timestamp
   * Example: New code generation feature available after 2025-06-01
   *
   * @generated from enum value: AVAILABILITY_CONTROL_TYPE_FUTURE_TIMESTAMP = 1;
   */
  FUTURE_TIMESTAMP = 1,
}

/**
 * Describes the enum entitlements.v3.AvailabilityControlType.
 */
export const AvailabilityControlTypeSchema: GenEnum<AvailabilityControlType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 5);

/**
 * QuotaLimitType enumerates the different types of quota limits
 *
 * @generated from enum entitlements.v3.QuotaLimitType
 */
export enum QuotaLimitType {
  /**
   * @generated from enum value: QUOTA_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Monthly usage quota or budget
   * Example: 10,000 requests per month for standard tier
   *
   * @generated from enum value: QUOTA_LIMIT_TYPE_MONTHLY = 1;
   */
  MONTHLY = 1,

  /**
   * Daily usage quota or budget
   * Example: 500 chat messages per day limit
   *
   * @generated from enum value: QUOTA_LIMIT_TYPE_DAILY = 2;
   */
  DAILY = 2,

  /**
   * Hourly usage quota or budget
   * Example: 50 image generations per hour
   *
   * @generated from enum value: QUOTA_LIMIT_TYPE_HOURLY = 3;
   */
  HOURLY = 3,

  /**
   * Cost-based quota measured in whole number units
   * Example: $25 maximum spend per month
   *
   * @generated from enum value: QUOTA_LIMIT_TYPE_COST = 4;
   */
  COST = 4,

  /**
   * Credits-based quota for transaction systems
   * Example: 100 credits allocated per month
   *
   * @generated from enum value: QUOTA_LIMIT_TYPE_CREDITS = 5;
   */
  CREDITS = 5,
}

/**
 * Describes the enum entitlements.v3.QuotaLimitType.
 */
export const QuotaLimitTypeSchema: GenEnum<QuotaLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 6);

/**
 * BatchLimitType enumerates the different types of batch limits
 *
 * @generated from enum entitlements.v3.BatchLimitType
 */
export enum BatchLimitType {
  /**
   * @generated from enum value: BATCH_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum number of items in a single batch
   * Example: 100 maximum documents in a batch upload
   *
   * @generated from enum value: BATCH_LIMIT_TYPE_SIZE = 1;
   */
  SIZE = 1,

  /**
   * Maximum number of batches in a time period
   * Example: 10 batch operations per day
   *
   * @generated from enum value: BATCH_LIMIT_TYPE_FREQUENCY = 2;
   */
  FREQUENCY = 2,
}

/**
 * Describes the enum entitlements.v3.BatchLimitType.
 */
export const BatchLimitTypeSchema: GenEnum<BatchLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 7);

/**
 * WorkflowLimitType enumerates the different types of workflow limits
 *
 * @generated from enum entitlements.v3.WorkflowLimitType
 */
export enum WorkflowLimitType {
  /**
   * @generated from enum value: WORKFLOW_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Maximum number of steps allowed in a single workflow execution
   * Example: Allowing up to 5 steps for basic tier
   *
   * @generated from enum value: WORKFLOW_LIMIT_TYPE_MAX_STEPS = 1;
   */
  MAX_STEPS = 1,

  /**
   * Maximum depth for recursive or nested workflows
   * Example: Limiting workflow nesting to 3 levels deep
   *
   * @generated from enum value: WORKFLOW_LIMIT_TYPE_MAX_DEPTH = 2;
   */
  MAX_DEPTH = 2,

  /**
   * Maximum cumulative time across all steps in seconds
   * Example: Limiting total workflow execution time to 60 seconds
   *
   * @generated from enum value: WORKFLOW_LIMIT_TYPE_CUMULATIVE_RUNTIME = 3;
   */
  CUMULATIVE_RUNTIME = 3,

  /**
   * Maximum number of distinct actions/tools available
   * Example: Allowing access to 5 tools for standard tier
   *
   * @generated from enum value: WORKFLOW_LIMIT_TYPE_AVAILABLE_ACTIONS = 4;
   */
  AVAILABLE_ACTIONS = 4,
}

/**
 * Describes the enum entitlements.v3.WorkflowLimitType.
 */
export const WorkflowLimitTypeSchema: GenEnum<WorkflowLimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 8);

/**
 * APILimitType enumerates the different types of API limits
 *
 * @generated from enum entitlements.v3.APILimitType
 */
export enum APILimitType {
  /**
   * @generated from enum value: API_LIMIT_TYPE_UNSPECIFIED = 0;
   */
  API_LIMIT_TYPE_UNSPECIFIED = 0,

  /**
   * Maximum number of unique API keys allowed
   * Example: 10 API keys for enterprise accounts
   *
   * @generated from enum value: API_LIMIT_TYPE_MAX_KEYS = 1;
   */
  API_LIMIT_TYPE_MAX_KEYS = 1,

  /**
   * Maximum number of integrations allowed
   * Example: 5 third-party integrations for premium tier
   *
   * @generated from enum value: API_LIMIT_TYPE_INTEGRATIONS = 2;
   */
  API_LIMIT_TYPE_INTEGRATIONS = 2,

  /**
   * Maximum number of custom models allowed
   * Example: 3 fine-tuned models for enterprise accounts
   *
   * @generated from enum value: API_LIMIT_TYPE_MAX_CUSTOM_MODELS = 3;
   */
  API_LIMIT_TYPE_MAX_CUSTOM_MODELS = 3,
}

/**
 * Describes the enum entitlements.v3.APILimitType.
 */
export const APILimitTypeSchema: GenEnum<APILimitType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 9);

/**
 * ComplianceControlType enumerates the different types of compliance controls
 *
 * @generated from enum entitlements.v3.ComplianceControlType
 */
export enum ComplianceControlType {
  /**
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Whether audit logging is enabled
   * Example: Enabling comprehensive audit logging for enterprise tier
   *
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_AUDIT_LOGGING = 1;
   */
  AUDIT_LOGGING = 1,

  /**
   * Audit log retention period in days
   * Example: 365-day retention for regulatory compliance
   *
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_AUDIT_RETENTION = 2;
   */
  AUDIT_RETENTION = 2,

  /**
   * Data residency requirements
   * Example: EU-only data processing for GDPR compliance
   *
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_DATA_RESIDENCY = 3;
   */
  DATA_RESIDENCY = 3,

  /**
   * PII handling policy level
   * Example: Medical-grade PII protection for healthcare customers
   *
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_PII_HANDLING = 4;
   */
  PII_HANDLING = 4,

  /**
   * Content filtering level
   * Example: Strict content filtering for educational institutions
   *
   * @generated from enum value: COMPLIANCE_CONTROL_TYPE_CONTENT_FILTERING = 5;
   */
  CONTENT_FILTERING = 5,
}

/**
 * Describes the enum entitlements.v3.ComplianceControlType.
 */
export const ComplianceControlTypeSchema: GenEnum<ComplianceControlType> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 10);

/**
 * ComplianceDataResidency defines where data can be stored and processed
 *
 * @generated from enum entitlements.v3.ComplianceDataResidency
 */
export enum ComplianceDataResidency {
  /**
   * @generated from enum value: COMPLIANCE_DATA_RESIDENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Data may be stored and processed anywhere as determined by us.
   *
   * @generated from enum value: COMPLIANCE_DATA_RESIDENCY_AUTO = 1;
   */
  AUTO = 1,
}

/**
 * Describes the enum entitlements.v3.ComplianceDataResidency.
 */
export const ComplianceDataResidencySchema: GenEnum<ComplianceDataResidency> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 11);

/**
 * CompliancePIIHandling defines how PII should be processed and displayed
 *
 * @generated from enum entitlements.v3.CompliancePIIHandling
 */
export enum CompliancePIIHandling {
  /**
   * @generated from enum value: COMPLIANCE_PII_HANDLING_UNSPECIFIED = 0;
   */
  COMPLIANCE_PII_HANDLING_UNSPECIFIED = 0,

  /**
   * No special PII handling
   * Example: Standard data handling without PII-specific protections
   *
   * @generated from enum value: COMPLIANCE_PII_HANDLING_NONE = 1;
   */
  COMPLIANCE_PII_HANDLING_NONE = 1,
}

/**
 * Describes the enum entitlements.v3.CompliancePIIHandling.
 */
export const CompliancePIIHandlingSchema: GenEnum<CompliancePIIHandling> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 12);

/**
 * ComplianceContentFiltering defines content moderation levels
 *
 * @generated from enum entitlements.v3.ComplianceContentFiltering
 */
export enum ComplianceContentFiltering {
  /**
   * @generated from enum value: COMPLIANCE_CONTENT_FILTERING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No content filtering applied
   * Example: Unrestricted creative content for professional users
   *
   * @generated from enum value: COMPLIANCE_CONTENT_FILTERING_NONE = 1;
   */
  NONE = 1,

  /**
   * Changes require human review before publication and distribution
   * Example: Legal document generation requires attorney review
   *
   * @generated from enum value: COMPLIANCE_CONTENT_FILTERING_MODERATION_REQUIRED = 2;
   */
  MODERATION_REQUIRED = 2,
}

/**
 * Describes the enum entitlements.v3.ComplianceContentFiltering.
 */
export const ComplianceContentFilteringSchema: GenEnum<ComplianceContentFiltering> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_entitlements, 13);

